import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {SureFlowUnitData} from '../../model/sure-flow-unit-data';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SelectionItem} from '../../selections/selection-item';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'app-rearrange-sure-flow-units-dialog',
    templateUrl: './rearrange-sure-flow-units-dialog.component.html',
    styleUrls: ['./rearrange-sure-flow-units-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatButton, MatIcon]
})
export class RearrangeSureFlowUnitsDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<RearrangeSureFlowUnitsDialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  private readonly units: SureFlowUnitData[];
  unitSelections!: SelectionItem[];
  selectedUnitId!: number;

  constructor() {
    const data = this.data;

    this.units = data.units;
  }

  ngOnInit(): void {
    this.unitSelections = [];
    let sequence: number = 1;
    for (const unit of this.units) {
      const unitSelection: SelectionItem = new SelectionItem();
      unitSelection.id = unit.id;
      unitSelection.description = unit.userTag || ('Unit ' + sequence);
      sequence++;
      this.unitSelections.push(unitSelection);
    }
  }

  canMoveUp(): boolean {
    const selectedUnit = this.getSelectedUnit();
    return (selectedUnit?.id || 0) > 0 && this.unitSelections.indexOf(selectedUnit) > 0;
  }

  private getSelectedUnit(): SelectionItem {
    const numericId: number = +this.selectedUnitId;
    return !isNaN(numericId) ? this.unitSelections.filter(selection => selection.id === numericId)[0] : undefined!;
  }

  moveUp(): void {
    if (this.canMoveUp()) {
      const selectedUnit = this.getSelectedUnit();
      const oldIndex = this.unitSelections.indexOf(selectedUnit);
      const newIndex = oldIndex - 1;
      this.moveSelectionItem(oldIndex, newIndex);
    }
  }

  private moveSelectionItem(oldIndex: number, newIndex: number): void {
    const selectedUnit = this.getSelectedUnit();
    const otherMovedItem = this.unitSelections[newIndex];
    const rearranged: SelectionItem[] = [];
    for (let currentIndex = 0; currentIndex < this.unitSelections.length; currentIndex++) {
      if (oldIndex === currentIndex) {
        rearranged.push(otherMovedItem);
      } else if (newIndex === currentIndex) {
        rearranged.push(selectedUnit);
      } else {
        rearranged.push(this.unitSelections[currentIndex]);
      }
    }
    this.unitSelections = rearranged;
  }

  canMoveDown(): boolean {
    const selectedUnit = this.getSelectedUnit();
    return (selectedUnit?.id || 0) > 0 && this.unitSelections.indexOf(selectedUnit) < (this.unitSelections.length - 1);
  }

  moveDown(): void {
    if (this.canMoveDown()) {
      const selectedUnit = this.getSelectedUnit();
      const oldIndex = this.unitSelections.indexOf(selectedUnit);
      const newIndex = oldIndex + 1;
      this.moveSelectionItem(oldIndex, newIndex);
    }
  }

  moveToTop(): void {
    const selectedUnit = this.getSelectedUnit();
    if (selectedUnit) {
      const oldIndex = this.unitSelections.indexOf(selectedUnit);
      if (oldIndex > 0) {
        this.moveSelectionItem(oldIndex, 0);
      }
    }
  }

  moveToBottom(): void {
    const selectedUnit = this.getSelectedUnit();
    if (selectedUnit) {
      const oldIndex = this.unitSelections.indexOf(selectedUnit);
      const newIndex = this.unitSelections.length - 1;
      if (oldIndex < newIndex) {
        this.moveSelectionItem(oldIndex, newIndex);
      }
    }
  }

  save(): void {
    const rearranged: SureFlowUnitData[] = [];
    for (const item of this.unitSelections) {
      const unitData = this.units.filter(unit => unit.id === item.id)[0];
      rearranged.push(unitData);
    }
    this.dialogRef.close(rearranged);
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
